import React from "react";

import { useFormContext } from "react-hook-form";

import { FormInputField } from "@components-shared/desktop/inputs";
import { useValueAvailabilityDebounce } from "@state/hooks/shared";

export default function OnboardingRegistrationUsername(props: {
	checkUserNameAvailability: (data: string) => Promise<boolean>;
	labelClassName?: string;
	disabled?: boolean;
}) {
	const { checkUserNameAvailability, labelClassName, disabled } = props;
	const {
		formState: { errors },
		clearErrors,
		getValues,
		trigger,
	} = useFormContext();

	const debouncer = useValueAvailabilityDebounce();

	return (
		<FormInputField
			id="userName"
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml"
			name="username"
			label="registration:USERNAME_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:USERNAME_PLACEHOLDER"
			pattern={{
				value: /^[a-zA-Z0-9_-]{6,20}$/,
				message: "registration:USERNAME_CHARACTERS_TW",
			}}
			validate={{
				isAvailable: async (value: any) => {
					if (errors?.["username"]) {
						clearErrors("username");
					}

					const isAvailable = await debouncer(
						value,
						checkUserNameAvailability
					);

					return isAvailable || "registration:USERNAME_NOT_AVAILABLE";
				},
				passValidate: () => {
					if (getValues("password")) {
						trigger("password");
					} else {
						clearErrors("password");
					}
				},
			}}
			required
			disabled={disabled}
		/>
	);
}
